var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.77983,
    cy: 10.116,
    r: 3.67243,
    stroke: "white",
    strokeWidth: 1.83622
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2603 15.0065C13.9152 16.5127 11.9584 17.4608 9.78023 17.4608C5.72378 17.4608 2.43537 14.1724 2.43537 10.116C2.43537 6.05953 5.72378 2.77112 9.78023 2.77112C13.8367 2.77112 17.1251 6.05953 17.1251 10.116C17.1251 11.2117 16.8852 12.2514 16.4549 13.1854L17.9505 14.3082C18.5966 13.0515 18.9613 11.6263 18.9613 10.116C18.9613 5.04542 14.8508 0.934906 9.78023 0.934906C4.70966 0.934906 0.599152 5.04542 0.599152 10.116C0.599152 15.1866 4.70966 19.2971 9.78023 19.2971C12.559 19.2971 15.0494 18.0626 16.733 16.1122L15.2603 15.0065Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.e563299436ce484280cecd6b8e9f6ece.svg";
export { ForwardRef as ReactComponent };